module.exports = {
    API_BASE_URL: 'https://sokar.es/api' // Ruta base de la API
};